import $ from "jquery";


function tab_height(){
    $('.tabanimationcontainer').animate({
        height: ($('.tabscontainer').height() + 100) + 'px'
    }, 100);
}

function active_tab(tabid, obj, parent){
    var tabAnimationContainer = parent.find('.tabanimationcontainer');
    var tabContainer = parent.find('.tabcontainer');
    var activeTab = parent.find('.' + tabid);
    if (obj.hasClass('activetab')) {

    } else {
        $('.activetab').removeClass('activetab');
        obj.addClass('activetab');

// Scroll the active tab into view on mobile
        obj[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

        tabAnimationContainer.animate({ left: '-100px', opacity: "0" }, 200, function() {
            tabAnimationContainer.css("left", "100px");
            tabContainer.hide();
            activeTab.show();
            tabAnimationContainer.animate({
                left: '0px',
                opacity: '1',
                height: (activeTab.height() + 100) + 'px'
            }, 300);
        });
    }
}

function update_arrow_state(parent) {
    var tabs = parent.find('.taboption');
    var activeIndex = tabs.index(tabs.filter('.activetab'));
    parent.find('.tab-prev').toggleClass('disabled', activeIndex === 0);
    parent.find('.tab-next').toggleClass('disabled', activeIndex === tabs.length - 1);
}

window.addEventListener('DOMContentLoaded', (event) => {
    tab_height();
});

$('.tab-con').each(function() {
    update_arrow_state($(this));
});

$(window).resize(function() {
    tab_height();
});


$('.taboption').click(function(event) {
    var tabid = $(event.target).attr('id');
    var obj = $(event.target);
    var parent = obj.closest(".tab-con");
    active_tab(tabid, obj, parent);
    update_arrow_state(parent);
});

$('.tab-con').on('click', '.tab-prev, .tab-next', function(event) {
    var parent = $(this).closest('.tab-con');
    var tabs = parent.find('.taboption');
    var activeIndex = tabs.index(tabs.filter('.activetab'));
    var isPrev = $(this).hasClass('tab-prev');
    var nextIndex = isPrev ? activeIndex - 1 : activeIndex + 1;
    if (nextIndex < 0 || nextIndex >= tabs.length) return;
    var nextTab = tabs.eq(nextIndex);
    var tabid = nextTab.attr('id');
    active_tab(tabid, nextTab, parent);
    update_arrow_state(parent);
});